import { render, staticRenderFns } from "./InventoryAdvancePaymentAttachmentsListItem.vue?vue&type=template&id=50c52aaa&"
import script from "./InventoryAdvancePaymentAttachmentsListItem.vue?vue&type=script&lang=ts&"
export * from "./InventoryAdvancePaymentAttachmentsListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports